<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-10"></a>
<h2 class="fm-head1">Acknowledgements and Dedications</h2>
<p class="nonindent">I wish to thank Pen and Sword Books for giving me the incentive to follow through with this project and agreeing to publish the book, particularly as I am a first-time author. My particular thanks go to Aileen at P&amp;S for answering the many questions I had throughout the process. More generally I would like to thank my family and friends (you know who you are) for their support and encouragement, and for assuring me that the topic sounded interesting. The proof of the pudding is in the reading.</p>
<p class="indent">Bearing in mind that this book is as much about life as it is death, I am keen to dedicate it to two individuals: Joy Bradford, who sadly departed this world three years ago now, and baby Alba-Rose, who as I type these words is not three weeks old and has her whole life ahead of her.</p>
<p class="right">Ben Norman, August 2019</p>
<a id="VPS-11"></a>
<div class="img_container"><img alt="image" src="images/Img_11_001.jpg"/>
<p class="footnote">1. Death as king, by an unknown engraver.</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Dedication.vue?a4033f36